import { ArrowUp } from "lucide-react";

const Footer = () => {
  const toTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.6 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-[#23201D] py-16 text-[#FAF8F5] md:py-20" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col justify-between gap-12 md:flex-row md:items-end">
          <div>
            <p className="font-serif text-5xl font-light tracking-tight sm:text-6xl">
              Simran <span className="italic text-[#C46B4E]">Kaur</span>
            </p>
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.22em] text-[#FAF8F5]/50">
              Integrative Psychotherapy &middot; NCPS 7249 &middot; Online
            </p>
            <img
              src="/ncps-logo.png"
              alt="NCPS Accredited Registrant — MNCPS (Acc.)"
              className="mt-6 h-16 w-auto rounded-xl"
              data-testid="footer-ncps-logo"
            />
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-[#FAF8F5]/70">
            <a href="#about" className="transition-colors duration-300 hover:text-[#FAF8F5]">About</a>
            <a href="#services" className="transition-colors duration-300 hover:text-[#FAF8F5]">Services</a>
            <a href="#areas" className="transition-colors duration-300 hover:text-[#FAF8F5]">Areas</a>
            <a href="#approach" className="transition-colors duration-300 hover:text-[#FAF8F5]">Credentials</a>
            <a href="#contact" className="transition-colors duration-300 hover:text-[#FAF8F5]">Contact</a>
          </nav>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-6 border-t border-[#3B3530] pt-8 md:flex-row md:items-center">
          <p className="max-w-xl text-xs leading-relaxed text-[#FAF8F5]/45">
            Practising within the NCPS ethical framework (membership no. NCPS7249). This website is not for emergencies —
            if you are in crisis, contact Samaritans on 116 123 (UK, 24/7) or call 999.
          </p>
          <div className="flex items-center gap-6">
            <p className="text-xs text-[#FAF8F5]/45">&copy; 2026 Simran Kaur Psychotherapy</p>
            <button
              onClick={toTop}
              data-testid="footer-back-to-top"
              aria-label="Back to top"
              className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-[#3B3530] text-[#FAF8F5]/70 transition-all duration-300 hover:border-[#C46B4E] hover:bg-[#C46B4E] hover:text-[#FAF8F5]"
            >
              <ArrowUp className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
